import { HomeOutlined } from '@ant-design/icons'

import { RouteItem } from '@eastcoal/router/types/route'

import { HomePage } from './index'

export const homeRoute: RouteItem = {
  title: '首页',
  path: '/',
  icon: <HomeOutlined />,
  element: <HomePage />
}
